export class Srating {
    
    public like:number;
    public uid:string;
    public model:string;

    constructor(like:number,uid:string,model:string){
        
        this.like=like;
        this.uid=uid;
        this.model=model;
    }
}


// WEBPACK FOOTER //
// G:/phoneinfo2/phoneinfo/src/app/models/srating.model.ts